// extracted by mini-css-extract-plugin
export default {"globalPreviewPromotionScale":"2.4","md-menu-content":"_base-link_md-menu-content_meELm","cursor":"_base-link_cursor_XfLFc"};